var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5850",
    "data-name": "Group 5850",
    transform: "translate(-2014 -1521)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_109",
    "data-name": "Ellipse 109",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(2014 1521)",
    fill: "#00263e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M63.518,0H50.13a3.553,3.553,0,0,0-3.548,3.548V16.667h-.347a1.429,1.429,0,0,0-1.43,1.43v8.67a1.429,1.429,0,0,0,1.43,1.43h.347v1.59a3.552,3.552,0,0,0,3.548,3.548H68.4a3.551,3.551,0,0,0,3.547-3.548V8.4ZM47.171,19.287a12.246,12.246,0,0,1,1.838-.124,3.871,3.871,0,0,1,2.462.642,2.662,2.662,0,0,1,1.017,2.266,3.048,3.048,0,0,1-1,2.435,4.317,4.317,0,0,1-2.774.776,11.759,11.759,0,0,1-1.543-.089V19.287ZM68.4,31.161H50.13a1.376,1.376,0,0,1-1.374-1.375V28.2H65.785a1.429,1.429,0,0,0,1.43-1.43V18.1a1.429,1.429,0,0,0-1.43-1.43H48.756V3.548A1.376,1.376,0,0,1,50.13,2.175l12.575-.013V6.81a2.461,2.461,0,0,0,2.46,2.46l4.554-.013.051,20.528A1.375,1.375,0,0,1,68.4,31.161Zm-15.291-8.9a2.91,2.91,0,0,1,2.926-3.149,2.8,2.8,0,0,1,2.855,3.042,2.866,2.866,0,0,1-2.953,3.166A2.8,2.8,0,0,1,53.107,22.259Zm9.754,1.926a3.407,3.407,0,0,0,1.133-.2l.2,1.061a3.862,3.862,0,0,1-1.543.259,2.859,2.859,0,0,1-3.15-3.006,3.065,3.065,0,0,1,3.283-3.194,3.557,3.557,0,0,1,1.481.267l-.276,1.08a2.924,2.924,0,0,0-1.142-.223,1.809,1.809,0,0,0-1.918,1.99A1.8,1.8,0,0,0,62.861,24.185Z",
    transform: "translate(1985.194 1534.333)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoc);
export default __webpack_public_path__ + "static/media/icon-doc.a91509ae152d867c868a270025dc7673.svg";
export { ForwardRef as ReactComponent };